import numeral from "numeral";

export function parseToNumber(value: any): number | null {
  if (value) {
    const num = parseFloat(value.toString().replace(",", "."));
    return num ? num : null;
  }
  return null;
}

export function valueOrEmpty(value: any, format: boolean = true): string | null {
  if (value) {
    const num = parseToNumber(value);
    if (num && !value.includes("x")) {
      return format ? numeral(num).format("0,0.00") : `${num}`;
    } else {
      value = value
        .toString()
        .replace("true", "ok")
        .replace("false", "nok");
    }
    return value;
  }

  return "";
}
